import React from 'react';
import {Image, View} from 'react-native';

import NoImage from '../../../images/LMG_IMAGE_NOT_AVAILABLE_transparent.png';
import {IMAGE_SIZES, imageStyles as styles} from '../styles';
import {ProductTileImageProps} from '../types';

/**
 * ProductTileImage - Renders product image only.
 *
 * Note: Stickers are NOT rendered here. They should be rendered at the
 * tile container level (ProductTileCarousel, ProductTileCompact) so they
 * can be positioned relative to the tile bounds, not the image bounds.
 * The `showStickers` prop is kept for API compatibility but sticker rendering
 * is handled by the parent variant component.
 */
function ProductTileImage({
  item,
  size = 'medium',
  showStickers: _showStickers = false,
  containerStyle,
  imageStyle,
  testID,
}: ProductTileImageProps) {
  const dimensions = IMAGE_SIZES[size];

  // Select appropriate image URL based on size
  const getImageUrl = () => {
    const {links} = item;
    if (size === 'large' && links.large_image) return links.large_image;
    if (size === 'medium' && links.medium_image) return links.medium_image;
    return links.image || links.medium_image || links.large_image;
  };

  const imageUrl = getImageUrl();

  return (
    <View style={[styles.container, containerStyle]} testID={testID}>
      {imageUrl ? (
        <Image
          source={{uri: imageUrl}}
          style={[styles.image, dimensions, imageStyle]}
          resizeMode="contain"
          testID={testID ? `${testID}-image` : undefined}
        />
      ) : (
        <Image
          source={NoImage}
          style={[styles.image, dimensions, imageStyle]}
          resizeMode="contain"
          testID={testID ? `${testID}-fallback` : undefined}
        />
      )}
    </View>
  );
}

export default ProductTileImage;
